import classes from "./Finished.module.css";
import ButtonStepper from "../../components/ButtonStepper/ButtonStepper";
import phoneIcon from "../../assets/phone.svg";
import emailIcon from "../../assets/email.svg";
import locationIcon from "../../assets/location.svg";
import PersonPhoto from "../../assets/person-removebg-preview.png";
import { Fragment, useState } from "react";
import { useTranslation } from "../../I18n/Languages/LanguageContext";
import {
  getWorkTimeOptions,
  getInformationSourceOptions,
  getExtraQuestionOptions,
  getLanguageOptions,
  getLanguageLevelOptions,
  getGenderOptions
} from "../../utils/translatedOptions";

const FinishedAplication = ({
  onBack,
  onSubmit,
  formData,
  jobOptions,
  jobsPositions,
}) => {
  const { t } = useTranslation();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  };

  const getWorkTimeLabel = (workTimeId) => {
    const translatedOptions = getWorkTimeOptions(t);
    const found = translatedOptions.find(
      (option) => String(option.value) === String(workTimeId)
    );
    return found ? found.label : `Work Time ${workTimeId}`;
  };

  const getInformationSourceLabel = (informationSourceId) => {
    const translatedOptions = getInformationSourceOptions(t);
    const found = translatedOptions.find(
      (option) => String(option.value) === String(informationSourceId)
    );
    return found ? found.label : `Information Source ${informationSourceId}`;
  };

  const getExtraQuestionLabel = (extraQuestionId) => {
    const translatedOptions = getExtraQuestionOptions(t);
    const found = translatedOptions.find(
      (option) => String(option.value) === String(extraQuestionId)
    );
    return found ? found.label : `Extra Question ${extraQuestionId}`;
  };

  const getLanguageLabel = (value) => {
    const options = getLanguageOptions(t);
    const found = options.find((opt) => opt.value === value);
    return found ? found.label : value || "-";
  };

  const getLanguageLevelLabel = (value) => {
    const options = getLanguageLevelOptions(t);
    const found = options.find((opt) => opt.value === value);
    return found ? found.label : value || "-";
  };

  const getGenderLabel = (value) => {
    const options = getGenderOptions(t);
    const found = options.find((opt) => opt.value === value);
    return found ? found.label : value || "-";
  };

  const getJobTitleFromJobOptions = (jobId) => {
    const job = jobOptions?.find((job) => String(job.value) === String(jobId));
    return job ? job.label : "-";
  };

  console.log("loggg", jobsPositions);

  return (
    <div className={classes.container}>
      <div className={classes.firstDivider}></div>
      <h2 className={classes.sectionTitle}>{t("summary")}</h2>
      {/* Personal Data */}
      <section className={classes.header}>
        {formData?.photoFile ? (
          <img
            src={
              formData.photoFile.fileObject
                ? URL.createObjectURL(formData.photoFile.fileObject)
                : PersonPhoto
            }
            alt="Uploaded"
            className={classes.photoPlaceholder}
          />
        ) : (
          <img
            src={PersonPhoto}
            alt="Placeholder"
            className={classes.photoPlaceholder}
          />
        )}

        <div className={classes.personalContainer}>
          <div className={classes.title}>{formData?.fullName}</div>
          <div className={classes.data}>
            <div className={classes.dataElement}>
              <div className={classes.bold}>{t("date_of_birth_label")}</div>
              <div className={classes.secondData}>
                {formData.datePersonal ? formData?.datePersonal : "-"}
              </div>
            </div>
            <div className={classes.dataElement}>
              <div className={classes.bold}>{t("nationality")}:</div>
              <div className={classes.secondData}>
                {formData.nationality ? formData?.nationality : "-"}
              </div>
            </div>
            <div className={classes.dataElement}>
              <div className={classes.bold}>{t("gender_label")}</div>
              <div className={classes.secondData}>
                {" "}
                {formData.gjinia
                  ? getGenderLabel(formData.gjinia)
                  : "-"}
              </div>
            </div>
          </div>
          <div className={classes.contactInfo}>
            <div className={classes.dataElement}>
              <div>
                <img
                  src={locationIcon}
                  alt="location"
                  className={classes.icon}
                />
              </div>
              <div className={classes.secondData}>
                {formData.adresaPersonal ? formData?.adresaPersonal : "-"}
              </div>
            </div>
            <div className={classes.dataElement}>
              <div>
                <img src={phoneIcon} alt="phone" className={classes.icon} />
              </div>
              <div className={classes.secondData}>
                {" "}
                {formData.telefon ? formData?.telefon : "-"}
              </div>
            </div>
            <div className={classes.dataElement}>
              <div>
                <img src={emailIcon} alt="email" className={classes.icon} />
              </div>
              <div className={classes.secondData}>
                {formData.email ? formData?.email : "-"}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Apply Data */}
      <div className={classes.headerEducation}>
        <div className={classes.stepsTitle}>{t("interest_for_work")}</div>
        <div className={classes.personalContainer}>
          <div
            style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}
          >
            <div className={classes.typeOfEmployment}>
              {t("position_applied_for")}
            </div>
            <div className={classes.secondData}>
              {formData.pozicioni
                ? getJobTitleFromJobOptions(formData.pozicioni)
                : "-"}
            </div>
          </div>
          <div
            style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}
          >
            <div className={classes.typeOfEmployment}>
              {t("employment_type_desired")}:
            </div>
            <div className={classes.secondData}>
              {formData.mundësiaPunë
                ? getWorkTimeLabel(formData?.mundësiaPunë)
                : "-"}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.divider}></div>

      {/* Education - Fixed to use correct field names */}
      {(formData?.educationHighestLevel ||
        formData?.educationInstitutionName ||
        formData?.educationFieldOfStudy ||
        formData?.educationGraduationYearEnd ||
        formData?.educationAdditionalCertifications) && (
        <>
          <div className={classes.headerEducation}>
            <div className={classes.stepsTitle}>
              {t("education_background")}
            </div>
            <div className={classes.personalContainer}>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "flex-start",
                }}
              >
                {formData.educationHighestLevel && (
                  <div className={classes.Lnagugage}>
                    {formData.educationHighestLevel}
                  </div>
                )}
                {formData.educationFieldOfStudy && (
                  <>
                    <span className={classes.dotSeparator}>•</span>
                    <div className={classes.education}>
                      {formData.educationFieldOfStudy}
                    </div>
                  </>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "flex-start",
                }}
              >
                {formData.educationInstitutionName && (
                  <div className={classes.education}>
                    {formData.educationInstitutionName}
                  </div>
                )}
                {formData.educationGraduationYearEnd && (
                  <>
                    <span className={classes.dotSeparator}>•</span>
                    <div className={classes.education}>
                      {formData.educationGraduationYearEnd}
                    </div>
                  </>
                )}
              </div>
              {formData.educationAdditionalCertifications && (
                <div className={classes.workDetails}>
                  {t("additional_certifications")}:{" "}
                  {formData.educationAdditionalCertifications}
                </div>
              )}
            </div>
          </div>
          <div className={classes.divider}></div>
        </>
      )}

      {/* Work Experience - Fixed to use correct field names */}
      {formData?.workExperience &&
        formData.workExperience.length > 0 &&
        !formData.workExperience.every(
          (exp) =>
            !exp.position &&
            !exp.employerName &&
            !exp.startDate &&
            !exp.endDate &&
            !exp.responsibilities &&
            !exp.employmentReasonForLeaving
        ) && (
          <>
            <div className={classes.headerEducation}>
              <div className={classes.stepsTitle}>
                {t("work_experience_section")}
              </div>
              <div className={classes.personalContainer}>
                {formData.workExperience.map((exp, index) => (
                  <Fragment key={index}>
                    <div style={{ display: "flex", gap: "12px" }}>
                      {exp.position && (
                        <div className={classes.Lnagugage}>{exp.position}</div>
                      )}
                      {exp.employerName && (
                        <Fragment>
                          <span className={classes.dotSeparator}>•</span>
                          <div className={classes.education}>
                            {exp.employerName}
                          </div>
                        </Fragment>
                      )}
                    </div>
                    <div className={classes.educationContainer}>
                      {exp.startDate && exp.endDate && (
                        <div className={classes.education}>
                          {exp.startDate} - {exp.endDate}
                        </div>
                      )}
                    </div>
                    {exp.responsibilities && (
                      <div className={classes.workDetails}>
                        {t("responsibilities")} {exp.responsibilities}
                      </div>
                    )}
                    {exp.employmentReasonForLeaving && (
                      <div className={classes.workDetails}>
                        {t("reason_for_leaving")}:{" "}
                        {exp.employmentReasonForLeaving}
                      </div>
                    )}
                  </Fragment>
                ))}
              </div>
            </div>
            <div className={classes.divider}></div>
          </>
        )}

      {/* Computer programs */}
      {(() => {
        const skillMappings = [
          { index: 1, key: "ms_office" },
          { index: 2, key: "customer_service" },
          { index: 3, key: "team_work" },
          { index: 4, key: "communication_skills" },
          { index: 5, key: "problem_solving" },
          { index: 6, key: "leadership" },
          { index: 7, key: "airport_systems" },
        ];

        const skills = [];

        skillMappings.forEach(({ index, key }) => {
          if (formData.computerPrograms && formData.computerPrograms[index]) {
            skills.push(t(key));
          }
        });

        // Handle the "other" skill separately
        if (formData.computerPrograms && formData.computerPrograms[8]) {
          const otherSkill = formData.otherComputerSkill || t("skills.other");
          skills.push(otherSkill);
        }

        return skills.length > 0 ? (
          <>
            <div className={classes.headerEducation}>
              <div className={classes.stepsTitle}>{t("computer_programs")}</div>
              <div className={classes.personalContainer}>
                {skills.map((skill, index) => (
                  <div key={index} className={classes.educationContainer}>
                    <div className={classes.dataTitle}>{skill}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.divider}></div>
          </>
        ) : null;
      })()}

      {/* Languages  */}
      {formData?.foreignLanguages &&
        formData.foreignLanguages.length > 0 &&
        !formData.foreignLanguages.every((lang) => !lang.language) && (
          <>
            <div className={classes.headerEducation}>
              <div className={classes.stepsTitle}>{t("languages_section")}</div>
              <div className={classes.personalContainer}>
                {formData.foreignLanguages.map((lang, index) => (
                  <Fragment key={index}>
                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        alignItems: "flex-start",
                        flexWrap: "wrap",
                      }}
                    >
                      {lang.language && (
                        <div className={classes.Lnagugage}>
                          {getLanguageLabel(lang.language)}:
                        </div>
                      )}
                      {lang.level && (
                        <div className={classes.education}>
                          {getLanguageLevelLabel(lang.level)}
                        </div>
                      )}
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
            <div className={classes.divider}></div>
          </>
        )}
      {/* Extra questions */}
      {(formData.relativesWorking || formData.jobApplicationNotice) && (
        <>
          <div className={classes.headerEducation}>
            <div className={classes.stepsTitle}>
              {t("additional_questions")}
            </div>
            <div className={classes.personalContainer}>
              {formData.relativesWorking && (
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                  }}
                >
                  <div className={classes.dataTitleExtra}>
                    {t("relatives_at_tia_detailed")}
                  </div>
                  <div className={classes.dataTitleExtraExtra}>
                    {getExtraQuestionLabel(formData.relativesWorking)}
                  </div>
                </div>
              )}

              {formData.relativesWorking === 1 &&
                formData.relativesWorkingNameSpecifications && (
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "flex-start",
                      flexWrap: "wrap",
                    }}
                  >
                    <div className={classes.dataTitleExtra}>
                      {t("relationship_placeholder")}
                    </div>
                    <div className={classes.dataTitleExtraExtra}>
                      {formData.relativesWorkingNameSpecifications}
                    </div>
                  </div>
                )}

              {formData.jobApplicationNotice && (
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                  }}
                >
                  <div className={classes.dataTitleExtra}>
                    {t("how_learned_vacancy_detailed")}
                  </div>
                  <div className={classes.dataTitleExtraExtra}>
                    {getInformationSourceLabel(formData.jobApplicationNotice)}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={classes.divider}></div>
        </>
      )}
      <ButtonStepper
        activeStep={8}
        stepsLength={9}
        onNext={handleSubmit}
        onBack={onBack}
        isLastStep={true}
        isSubmitWidth={true}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default FinishedAplication;
